/* Pure Indoor Living — product compare feature */
(function () {
  'use strict';

  var KEY = 'pil-compare';
  var MAX = 4;

  var SPEC_ROWS = [
    ['coverage_sqft', 'Coverage (sq ft)'],
    ['airflow_cfm', 'Airflow (CFM)'],
    ['filtration_stages', 'Filtration stages'],
    ['hepa_grade', 'HEPA grade'],
    ['carbon_weight_lbs', 'Activated carbon (lbs)'],
    ['noise_level', 'Noise level'],
    ['power_watts', 'Power (watts)'],
    ['dimensions', 'Dimensions'],
    ['weight_lbs', 'Weight (lbs)'],
    ['warranty', 'Warranty'],
    ['filter_life', 'Filter life'],
    ['best_for', 'Best for']
  ];

  function load() {
    try {
      var v = JSON.parse(localStorage.getItem(KEY));
      return Array.isArray(v) ? v : [];
    } catch (e) { return []; }
  }

  var items = load();

  function save() {
    try { localStorage.setItem(KEY, JSON.stringify(items)); } catch (e) {}
  }

  function isSelected(id) {
    return items.some(function (p) { return String(p.id) === String(id); });
  }

  function removeItem(id) {
    items = items.filter(function (p) { return String(p.id) !== String(id); });
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function formatValue(v) {
    if (v === null || v === undefined) return null;
    if (Array.isArray(v)) return v.length ? v.join(', ') : null;
    if (typeof v === 'number') return v.toLocaleString();
    var s = String(v).trim();
    return s === '' ? null : s;
  }

  var bar = document.getElementById('PilCompareBar');
  var drawer = document.getElementById('PilCompareDrawer');

  function renderBar() {
    if (!bar) return;
    document.body.classList.toggle('pil-compare-active', items.length > 0);
    var list = bar.querySelector('[data-compare-items]');
    var openBtn = bar.querySelector('[data-compare-open]');
    var count = bar.querySelector('[data-compare-count]');
    if (!items.length) {
      bar.hidden = true;
      closeDrawer();
      return;
    }
    bar.hidden = false;
    list.innerHTML = items.map(function (p) {
      return '<div class="pil-compare-bar__item">' +
        (p.image ? '<img src="' + esc(p.image) + '" alt="" decoding="async">' : '') +
        '<span class="pil-compare-bar__item-title">' + esc(p.title) + '</span>' +
        '<button type="button" class="pil-compare-bar__remove" data-compare-remove="' + esc(p.id) + '" aria-label="Remove ' + esc(p.title) + ' from compare">&times;</button>' +
        '</div>';
    }).join('');
    if (count) count.textContent = ' (' + items.length + ')';
    if (openBtn) openBtn.disabled = items.length < 2;
  }

  function syncCheckboxes() {
    var boxes = document.querySelectorAll('[data-compare-checkbox]');
    for (var i = 0; i < boxes.length; i++) {
      boxes[i].checked = isSelected(boxes[i].getAttribute('data-product-id'));
    }
  }

  var lastFocus = null;

  function renderTable() {
    if (!drawer) return;
    var mount = drawer.querySelector('[data-compare-table]');
    if (!mount) return;
    if (!items.length) {
      mount.innerHTML = '<p class="pil-compare-empty">No products selected.</p>';
      return;
    }

    var html = '<div class="pil-compare-table-wrap"><table class="pil-compare-table"><thead><tr><th class="pil-compare-table__label" scope="col"><span class="pil-visually-hidden">Specification</span></th>';
    items.forEach(function (p) {
      html += '<th scope="col" class="pil-compare-table__product">' +
        '<button type="button" class="pil-compare-table__remove" data-compare-remove="' + esc(p.id) + '" aria-label="Remove ' + esc(p.title) + ' from compare">&times;</button>' +
        (p.image ? '<a href="' + esc(p.url) + '" tabindex="-1"><img src="' + esc(p.image) + '" alt="' + esc(p.title) + '" decoding="async"></a>' : '') +
        '<a class="pil-compare-table__title" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
        (p.price ? '<div class="pil-compare-table__price">' + esc(p.price) + '</div>' : '') +
        '<a class="pil-compare-table__link" href="' + esc(p.url) + '">View details</a>' +
        '</th>';
    });
    html += '</tr></thead><tbody>';

    SPEC_ROWS.forEach(function (row) {
      var key = row[0];
      var label = row[1];
      var values = items.map(function (p) { return formatValue(p.specs && p.specs[key]); });
      var hasAny = values.some(function (v) { return v !== null; });
      if (!hasAny) return;
      html += '<tr><th scope="row" class="pil-compare-table__label">' + esc(label) + '</th>';
      values.forEach(function (v) {
        html += '<td>' + (v === null ? '<span class="pil-compare-table__na">&mdash;</span>' : esc(v)) + '</td>';
      });
      html += '</tr>';
    });

    html += '</tbody></table></div>';
    mount.innerHTML = html;
  }

  function openDrawer() {
    if (!drawer) return;
    renderTable();
    lastFocus = document.activeElement;
    drawer.hidden = false;
    document.body.classList.add('pil-compare-lock');
    var closeBtn = drawer.querySelector('.pil-compare-drawer__close');
    if (closeBtn) closeBtn.focus();
  }

  function closeDrawer() {
    if (!drawer || drawer.hidden) return;
    drawer.hidden = true;
    document.body.classList.remove('pil-compare-lock');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  var toastTimer = null;
  function toast(msg) {
    var el = document.getElementById('PilCompareToast');
    if (!el) {
      el = document.createElement('div');
      el.id = 'PilCompareToast';
      el.className = 'pil-compare-toast';
      el.setAttribute('role', 'status');
      document.body.appendChild(el);
    }
    el.textContent = msg;
    el.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove('is-visible'); }, 3000);
  }

  document.addEventListener('change', function (e) {
    var cb = e.target && e.target.closest ? e.target.closest('[data-compare-checkbox]') : null;
    if (!cb) return;
    var id = cb.getAttribute('data-product-id');
    if (cb.checked) {
      if (items.length >= MAX) {
        cb.checked = false;
        toast('You can compare up to ' + MAX + ' products at a time.');
        return;
      }
      if (!isSelected(id)) {
        var wrap = cb.closest('[data-compare-toggle]');
        var dataEl = wrap ? wrap.querySelector('[data-compare-data]') : null;
        if (!dataEl) return;
        try { items.push(JSON.parse(dataEl.textContent)); } catch (err) { return; }
      }
    } else {
      removeItem(id);
    }
    save();
    renderBar();
    syncCheckboxes();
    if (drawer && !drawer.hidden) renderTable();
  });

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var removeBtn = t.closest('[data-compare-remove]');
    if (removeBtn) {
      removeItem(removeBtn.getAttribute('data-compare-remove'));
      save();
      renderBar();
      syncCheckboxes();
      if (drawer && !drawer.hidden) {
        if (items.length) renderTable(); else closeDrawer();
      }
      return;
    }
    if (t.closest('[data-compare-open]')) { openDrawer(); return; }
    if (t.closest('[data-compare-clear]')) {
      items = [];
      save();
      renderBar();
      syncCheckboxes();
      closeDrawer();
      return;
    }
    if (t.closest('[data-compare-close]')) { closeDrawer(); }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  window.addEventListener('storage', function (e) {
    if (e.key !== KEY) return;
    items = load();
    renderBar();
    syncCheckboxes();
    if (drawer && !drawer.hidden) renderTable();
  });

  var syncQueued = false;
  var observer = new MutationObserver(function () {
    if (syncQueued) return;
    syncQueued = true;
    setTimeout(function () { syncQueued = false; syncCheckboxes(); }, 100);
  });

  function init() {
    renderBar();
    syncCheckboxes();
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
